import { render, staticRenderFns } from "./CreateVote.vue?vue&type=template&id=30aa6d33&scoped=true&"
import script from "./CreateVote.vue?vue&type=script&lang=js&"
export * from "./CreateVote.vue?vue&type=script&lang=js&"
import style0 from "./CreateVote.vue?vue&type=style&index=0&id=30aa6d33&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30aa6d33",
  null
  
)

export default component.exports